import script from "./NavBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavBar.vue?vue&type=script&setup=true&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=24864801&lang=css"

const __exports__ = script;

export default __exports__